module.exports = __webpack_public_path__ + "img/spades.03f45aef.png";